var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules",style:({ paddingBottom: _vm.$store.state.paddingBottom + 'px' })},[_c('NavigationBar',{scopedSlots:_vm._u([{key:"center",fn:function(){return [_c('span',{attrs:{"data-testid":"tippen-title"}},[_vm._v("Tippabgabe")])]},proxy:true}])}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }